// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"145":"54dac1d8","236":"2b58a27e","515":"5e7495b5","526":"8e1a7d05","543":"af46dc37","652":"8e1a7d05","924":"2295e9a0"}[chunkId] + ".chunk.css";
};